export * from './payments.service';
import { PaymentsService } from './payments.service';
export * from './serviceProviderAPI.service';
import { ServiceProviderAPIService } from './serviceProviderAPI.service';
export const APIS = [PaymentsService, ServiceProviderAPIService];
